import { X } from 'lucide-react';
import { useState } from 'react';

import { useAppExperienceMode } from '@/features/shared/hooks/useAppExperienceMode';

const dismissalKey = 'aarogyaflow:standalone-hint-dismissed';

export function StandaloneHintBanner() {
  const experienceMode = useAppExperienceMode();
  const [dismissed, setDismissed] = useState(
    () => typeof window !== 'undefined' && window.sessionStorage.getItem(dismissalKey) === 'true'
  );

  if (experienceMode !== 'mobile-browser' || dismissed) {
    return null;
  }

  function dismiss() {
    window.sessionStorage.setItem(dismissalKey, 'true');
    setDismissed(true);
  }

  return (
    <div
      className="fixed left-3 right-3 z-50 flex items-start gap-2 rounded-lg border border-sky-200 bg-sky-50 py-2 pl-3 pr-1 text-xs text-sky-800 shadow-soft dark:border-sky-800/40 dark:bg-sky-900/20 dark:text-sky-200"
      style={{ bottom: 'calc(var(--app-bottom-nav-space) + env(safe-area-inset-bottom) + 0.5rem)' }}
    >
      <p className="min-w-0 flex-1 py-1.5 leading-snug">
        Running in Safari mode. For full app mode: tap <strong>Share</strong> then{' '}
        <strong>Add to Home Screen</strong>, and launch from the AarogyaFlow icon.
      </p>
      <button
        type="button"
        aria-label="Dismiss app mode hint"
        className="grid h-11 w-11 shrink-0 place-items-center rounded-lg text-sky-700 transition hover:bg-sky-100 dark:text-sky-200 dark:hover:bg-sky-900/50"
        onClick={dismiss}
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
